module.exports = __webpack_public_path__ + "assets/Freccia_destra_v1.9843b04a.svg";